import { PaymentReport } from './PaymentReport'
import { withPaymentReport } from './withPaymentReport'

const Connected = withPaymentReport(PaymentReport)

export { Connected as PaymentReport }
